import React from "react";
import {ResidenceType} from "features/search/filters/enums";
import {Icon} from '@atoms/Media/Icon';

export const getResidenceTypeIcon = (residenceType:ResidenceType) => {
    switch (residenceType) {
        case ResidenceType.PLOT:
            return <Icon name="plot" thin />;
        case ResidenceType.SEMI_DETACHED_HOUSE:
            return <Icon name="semi-detached-house" thin />;
        case ResidenceType.TOWN_HOUSE:
        case ResidenceType.DETACHED_HOUSE:
            return <Icon name="terraced" thin />;
        case ResidenceType.APARTMENT:
            return <Icon name="appartment" thin />;
        case ResidenceType.HOUSE:
            return <Icon name="house" thin />;
        case ResidenceType.PARKING_BUILDING:
            return <Icon name="car" thin />;
        default:
            return null;
    }
};
